import { gql } from '@apollo/client';

export const GET_ALL_ROLES = gql`
  query GetAllRoles {
    findAll: getAllRoles {
      description
      name
      uuid
    }
  }
`;

export const CREATE_ROLES = gql`
  mutation SetUserRoles($data: [SetUserRolesPermissionsInput!]!) {
    setUserRolesPermissions(setUserRolesPermissionsInput: $data) {
      generalPermissions
      selectedTags
      selectedValue
      userAuth0ID
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DeleteRole($uuid: ID!) {
    deleteRole(uuid: $uuid)
  }
`;

export const UPDATE_ROLE = gql`
  mutation UpdateUser($data: UpdateRoleInput!) {
    updateRole(data: $data) {
      description
      name
      uuid
    }
  }
`;

export const ASSIGN_USER_TO_ROLES = gql`
  mutation AssignUserToRoles(
    $roleIds: [String!]!
    $userId: ID!
    $organizationUuid: ID!
  ) {
    assignUserToRoles(
      roleIds: $roleIds
      userId: $userId
      organizationUuid: $organizationUuid
    )
  }
`;

export const UNASSIGN_USER_FROM_ROLES = gql`
  mutation UnassignUserFromRoles(
    $roleIds: [String!]!
    $userId: ID!
    $organizationUuid: ID!
  ) {
    unAssignUserToRoles(
      roleIds: $roleIds
      userId: $userId
      organizationUuid: $organizationUuid
    )
  }
`;

export const ASSIGN_PANEL_TO_PERMISSION = gql`
  mutation AssignPanelToPermission(
    $panelUuid: ID!
    $permissionUuids: [String!]!
  ) {
    assignPanelToPermission(
      panelUuid: $panelUuid
      permissionUuids: $permissionUuids
    )
  }
`;

export const UNASSIGN_PANEL_TO_PERMISSION = gql`
  mutation UnassignPanelToPermission(
    $panelUuid: ID!
    $permissionUuids: [String!]!
  ) {
    unAssignPanelToPermission(
      panelUuid: $panelUuid
      permissionUuids: $permissionUuids
    )
  }
`;

export const GET_ROLE_BY_UUID = gql`
  query GetRoleByUuid($uuid: ID!) {
    getRoleByUuid(uuid: $uuid) {
      description
      name
      panels {
        name
        permissions {
          name
          uuid
        }
        uuid
      }
      uuid
    }
  }
`;

export const GET_USER_PERMISSIONS = gql`
  query GetUserPermissions($uuid: ID!, $organizationUuid: ID!) {
    getUserByUuid(uuid: $uuid, organizationUuid: $organizationUuid) {
      uuid
      name
      roles {
        generalPermissions
        selectedTags
        selectedValue
        userAuth0ID
      }
    }
  }
`;
